import type { SVGProps } from 'react';

const TrialRocketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12.2803 11.7005" fill="none" {...props}>
    <path
      d="M2.07449 11.578C2.15616 11.6597 2.26699 11.7005 2.37782 11.7005C2.49449 11.7005 2.60532 11.6538 2.69282 11.5663L3.66699 10.5688C3.83616 10.3938 3.83616 10.1197 3.66116 9.95051C3.48616 9.78717 3.21199 9.78717 3.04282 9.96217L2.06866 10.9597C1.89949 11.1347 1.89949 11.4088 2.07449 11.578Z"
      fill="#009E5E"
    />
    <path
      d="M6.26607 11.7005C6.26773 11.7005 6.26866 11.7005 6.26866 11.7005H6.26282L6.26607 11.7005Z"
      fill="#009E5E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.18699 11.6947C6.20738 11.6998 6.25451 11.7004 6.26607 11.7005C6.3757 11.6997 6.47945 11.6589 6.56032 11.5838L8.41532 9.86301C8.62532 9.67051 8.74199 9.39634 8.74199 9.11634V7.88551C11.4253 6.44467 12.5045 4.13467 12.242 0.442173C12.2303 0.22634 12.0553 0.057173 11.8395 0.039673C8.14699 -0.22866 5.83699 0.856339 4.39616 3.53384H3.16532C2.88532 3.53384 2.61116 3.65051 2.41866 3.86051L0.697822 5.71551C0.598655 5.81467 0.557822 5.95467 0.586988 6.09467C0.616155 6.23467 0.703655 6.35134 0.831988 6.40967C0.831988 6.40967 0.835435 6.41134 0.840065 6.41355C0.985172 6.48299 3.00205 7.44807 3.91782 8.36384C4.82928 9.28095 5.80116 11.3024 5.86839 11.4422C5.87044 11.4465 5.87199 11.4497 5.87199 11.4497C5.93616 11.578 6.05282 11.6655 6.18699 11.6947ZM8.45606 4.95716C9.10039 4.95716 9.62272 4.43482 9.62272 3.79049C9.62272 3.14616 9.10039 2.62383 8.45606 2.62383C7.81172 2.62383 7.28939 3.14616 7.28939 3.79049C7.28939 4.43482 7.81172 4.95716 8.45606 4.95716Z"
      fill="#009E5E"
    />
    <path
      d="M0.131988 10.913C0.213655 10.9947 0.324488 11.0355 0.435322 11.0355C0.551988 11.0355 0.662822 10.9888 0.750322 10.9013L2.37199 9.23301C2.54116 9.05801 2.54116 8.78384 2.36616 8.61467C2.19116 8.45134 1.91699 8.45134 1.74782 8.62634L0.126155 10.2947C-0.0430116 10.4697 -0.0430116 10.7438 0.131988 10.913Z"
      fill="#009E5E"
    />
  </svg>
);

export default TrialRocketIcon;
